// Convert date string from "YYYY-MM-DD" format to "MM/DD/YYYY" format
const convertDate = inputDate => {
	if (!inputDate) {
		return undefined;
	}
	// input date is in form YYYY-MM-DD, split on hyphen
	const splitDate = inputDate.split('-');
	// if input date is in unexpected format, return undefined
	if (splitDate.length !== 3) {
		return undefined;
	}
	// output date is in form MM/DD/YYYY
	return `${splitDate[1]}/${splitDate[2]}/${splitDate[0]}`;
};

export default convertDate;
